//
// Takes a string with '\n' characters, returns an array of <span> blocks
// with html <br /> instead of '\n'
//

import PropTypes from 'prop-types';
import { useMemo } from 'react';
// import { displayJson, logError } from '../../utils';

function LineBreaksToBr(props) {
  const { text } = props;

  // if ((!text) || (!text.split)) {
  //   logError(`LineBreaksToBr text="${displayJson(text)}" (${
  //     typeof text}) props=${displayJson(props)} (${typeof props})`);
  // }
  const linesSpans = useMemo(
    () => (text
      .split('\n')
      .map((line, index) => (
        <span key={index}>
          {(index) ? <br /> : null}
          {line}
        </span>
      ))),
    [text],
  );

  return linesSpans;
}

LineBreaksToBr.propTypes = {
  text: PropTypes.string,
};

export default LineBreaksToBr;
